import React from "react";
import { Link } from "react-router-dom";
import { Home, Mail } from "lucide-react";
import "../css/MainPage.css";
import "../css/NotFound.css";
import NotFoundImage from "../../assets/404.png";
import Header from "./Header/Header";
import Footer from "./Footer/footer";
import SEOHead from "./SEO/SEOHead";

const NotFound = () => {
  return (
    <>
      <SEOHead
        title="Page Not Found - Froth TestOps"
        description="The page you're looking for doesn't exist. Return to homepage or contact support for assistance."
        noIndex
      />
      <div className="fd-main-wrapper page-padding">
        <Header />
        <main className="nf">
          <div className="ft-container nf__grid">
            <div>
              <p className="nf__code">404</p>
              <h1 className="ft-display">
                Oops! <span>Page Not Found</span>
              </h1>
              <p className="ft-lead">
                This page doesn’t exist or was removed. We suggest you go back home, or get in touch if you were
                looking for something specific.
              </p>
              <div className="ft-btn-row">
                <Link to="/" className="ft-btn ft-btn--primary">
                  <Home size={18} aria-hidden="true" /> Back To Home
                </Link>
                <Link to="/contact" className="ft-btn ft-btn--ghost">
                  <Mail size={18} aria-hidden="true" /> Contact Us
                </Link>
              </div>
            </div>
            <img src={NotFoundImage} alt="" className="nf__image" />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
